angular.module('app.directives').directive('clientPreview', ($templateCache, $interpolate) => {
    const id = 'preview_client_modal';
    const wrapper = $templateCache.get('/directives/preview/client_preview_wrapper.html');
    const template = $templateCache.get('/directives/preview/client_preview_template.html');
    const interpolated = $interpolate(template)();
    const compiled = _.template(interpolated);

    angular.element('body').append(wrapper);

    return {
        restrict: 'EA',
        scope: {},
        bindToController: {
            client: '<',
            iconClass: '@',
        },
        templateUrl: '/directives/preview/client_preview_link.html',
        controllerAs: 'clientPreview',
        controller() {
            const vm = this;

            vm.id = id;
            vm.previewClient = () => {
                const html = compiled({
                    client: vm.client || {},
                });
                document.getElementById(id).innerHTML = html;
            };
        },
    };
});
